import React from 'react';
import { useStore } from '../../store/useStore';
import { Input, Select } from '../ui';
import { CreditCard } from 'lucide-react';

export function M15_Financial() {
  const { financial, setFinancial } = useStore();

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFinancial({ [e.target.name]: e.target.value });
  };

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-2">
          <CreditCard size={18} className="text-gray-500" />
          <h3 className="font-semibold text-gray-900">Dados do Contrato</h3>
        </div>
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
           <Input 
                label="Plano Contratado (Serviços da Agência)" 
                name="planoContratado" 
                value={financial.planoContratado} 
                onChange={handleTextChange} 
                placeholder="Ex: Plano Growth (Tráfego + Copy)" 
           />
           <div className="relative">
               <Input 
                    label="Valor Mensal do Fee" 
                    name="valorMensal" 
                    value={financial.valorMensal} 
                    onChange={handleTextChange} 
                    placeholder="0,00" 
                    className="pl-9"
               />
               <span className="absolute left-3 top-8 text-gray-500 font-medium text-sm border-r border-gray-200 pr-1">R$</span>
           </div>
           
           <Select 
            label="Forma de Pagamento" 
            name="formaPagamento" 
            value={financial.formaPagamento} 
            onChange={handleTextChange} 
            options={[
                {label: 'Selecionar...', value: ''},
                {label: 'Boleto Bancário', value: 'Boleto'},
                {label: 'PIX', value: 'PIX'},
                {label: 'Cartão de Crédito', value: 'Cartao'},
                {label: 'Transferência (TED/DOC)', value: 'Transferencia'},
            ]}
           />
           <Input 
                label="Dia de Cobrança / Vencimento" 
                type="number" 
                min="1" 
                max="31" 
                name="diaCobranca" 
                value={financial.diaCobranca} 
                onChange={handleTextChange} 
                placeholder="Ex: 5" 
           />
           <Input 
                label="Responsável pelo Financeiro no Cliente" 
                name="responsavelFinanceiro" 
                value={financial.responsavelFinanceiro} 
                onChange={handleTextChange} 
                placeholder="Nome da pessoa do financeiro" 
           />
        </div>
      </div>

    </div>
  );
}
